// extracted by mini-css-extract-plugin
export default {"appButton":"energy-usage_appButton__ezbKe"};